

























































































































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import { statisticsModule } from '@/store/modules/frames/statistics.module';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import GTemplateTopicForm from '@/components/GTopicForm.vue';
import { tagModule } from '@/store/modules/entities/tag.module';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import GStatisticsFilter from '@/views/GStatistics/GStatisticsFilter.vue';
import { StatisticsFilterParam } from '@/models/statistics/statistics-filter-param';
import { SchoolClass } from '@/models/school-class/school-class';
import GStatisticsBoxPlot from '@/views/GStatistics/GStatisticsChart.vue';
import { masterModule } from '@/store/modules/entities/master.module';
import { Competency } from '@/models/competency/competency';
import { EChartService } from '@/service/echart/echart.service';
import GStatisticsChart from '@/views/GStatistics/GStatisticsChart.vue';
import GStatisticsTrendAnalysisChart from '@/views/GStatistics/GStatisticsTrendAnalysisChart.vue';
import GStatisticsAllCompetencyGrowthChart from '@/views/GStatistics/GStatisticsAllCompetencyGrowthChart.vue';
import { GEnum } from '@/constants/enum.defination';
import { CompetencyBoxplotEchartService } from '@/service/echart/competency-boxplot.echart.service';
import { OtherCompetencyBoxplotEchartService } from '@/service/echart/other-competency-boxplot.echart.service';
import { MvplotCompetencyMappingEchartService } from '@/service/echart/mvplot-competency-mapping.echart.service';
import { MvplotStudentMappingEchartService } from '@/service/echart/mvplot-student-mapping.echart.service';
import { CharacterMappingEchartService } from '@/service/echart/character-mapping.echart.service';
import { CharacterBoxplotEchartService } from '@/service/echart/character-boxplot.echart.service';
import { NetworkEChartService } from '@/service/echart/network.echart.service';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import GLoading from '@/components/GLoading.vue';
import { SchoolGroupTrendAnalysis } from '@/models/school-group/school-group-trend-analysis';
import { TrendanalysisGrowthMindsetMapEchartService } from '@/service/echart/trendanalysis-growth-mindset-map.echart.service';
import { TrendanalysisPsychologicalSafetyEchartService } from '@/service/echart/trendanalysis-psychological-safety.echart.service';
import { TrendanalysisHumanitiesOrSciencesEchartService } from '@/service/echart/trendanalysis-humanities-or-sciences.echart.service';
import { CustomCompetencyBoxplotEchartService } from '@/service/echart/custom-competency-boxplot.echart.service';
import { customCompetencyModule } from '@/store/modules/frames/custom-competency.module';
import GStatisticsBoxplotSubTableInfoTable from '@/components/GStatisticsBoxplotSubTableInfoTable.vue';
import { StatisticsCompetencyGrowthEchartService } from '@/service/echart/statistics-competency-growth.echart.service';

@Component({
  name: 'GStatistics',
  components: {
    GLoading,
    GStatisticsBoxPlot,
    GStatisticsFilter,
    GTemplateTopicForm,
    GTitleBar,
    GCustomBreadCrumb,
    GStatisticsChart,
    GStatisticsTrendAnalysisChart,
    GStatisticsBoxplotSubTableInfoTable,
    GStatisticsAllCompetencyGrowthChart,
  },
  computed: {},
  methods: {},
})
export default class GStatistics extends mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  lazy: boolean = false;
  growthMindsetMapDescriptionsColumn: object[] = [];
  growthMindsetMapDescriptions: object[] = [];

  async mounted() {
    statisticsModule.clean();
    masterModule.fetchCompetency().then((competencies: Competency[]) => {
      statisticsModule.setCompetencies(competencies);
      // 検索データは存在しないがコンピテンシーのラベルを反映させたいため実行
      this.flushChart();
      this.flushTrendAnalysisChart();
    });
    schoolClassModule.fetchGrades();
    schoolClassModule.fetchSchoolClasses();
    tagModule.fetchTags();
    evalSettingModule.fetchAllEvalSettings();

    customCompetencyModule.fetchCustomCompetencyBoxplotForGraph();

    this.breadCrumbItems = [
      {
        title: this.$t('HOME').toString(),
        icon: 'ios-home',
        routerPath: '/pages/home',
      },
      { title: this.$t('STATISTICS_INFORMATION').toString() },
    ];
    this.lazy = true;

    this.createColumn();

    this.growthMindsetMapDescriptions = [
      {
        zone: this.$t('GROWTH_MIND_SET_MAP_DESC_ZONE_1').toString(),
        score: this.$t('GROWTH_MIND_SET_MAP_DESC_SCORE_1').toString(),
        description: this.$t('GROWTH_MIND_SET_MAP_DESC_DESCRIPTION_1').toString(),
        favoritePhrase: this.$t('GROWTH_MIND_SET_MAP_DESC_FAVORITE_PHRASE_1').toString(),
      },
      {
        zone: this.$t('GROWTH_MIND_SET_MAP_DESC_ZONE_2').toString(),
        score: this.$t('GROWTH_MIND_SET_MAP_DESC_SCORE_2').toString(),
        description: this.$t('GROWTH_MIND_SET_MAP_DESC_DESCRIPTION_2').toString(),
        favoritePhrase: this.$t('GROWTH_MIND_SET_MAP_DESC_FAVORITE_PHRASE_2').toString(),
      },
      {
        zone: this.$t('GROWTH_MIND_SET_MAP_DESC_ZONE_3').toString(),
        score: this.$t('GROWTH_MIND_SET_MAP_DESC_SCORE_3').toString(),
        description: this.$t('GROWTH_MIND_SET_MAP_DESC_DESCRIPTION_3').toString(),
        favoritePhrase: this.$t('GROWTH_MIND_SET_MAP_DESC_FAVORITE_PHRASE_3').toString(),
      },
      {
        zone: this.$t('GROWTH_MIND_SET_MAP_DESC_ZONE_4').toString(),
        score: this.$t('GROWTH_MIND_SET_MAP_DESC_SCORE_4').toString(),
        description: this.$t('GROWTH_MIND_SET_MAP_DESC_DESCRIPTION_4').toString(),
        favoritePhrase: this.$t('GROWTH_MIND_SET_MAP_DESC_FAVORITE_PHRASE_4').toString(),
      },
    ];
  }

  get schoolGroupTrendAnalysis(): SchoolGroupTrendAnalysis {
    return statisticsModule.schoolGroupTrendAnalysis;
  }

  get selectedChartType(): GEnum.ChartType {
    return statisticsModule.selectedChartType;
  }

  get selectedTrendAnalysisChartType(): GEnum.TrendAnalysisChartType {
    return statisticsModule.selectedTrendAnalysisChartType;
  }

  get loading(): boolean {
    return statisticsModule.loading;
  }

  get chartTypeCompetencyBoxplot(): GEnum.ChartType.CompetencyBoxplot {
    return GEnum.ChartType.CompetencyBoxplot;
  }

  get chartTypeOtherCompetencyBoxplot(): GEnum.ChartType.OtherCompetencyBoxplot {
    return GEnum.ChartType.OtherCompetencyBoxplot;
  }

  get chartTypeCustomCompetencyBoxplot(): GEnum.ChartType.CustomCompetencyBoxplot {
    return GEnum.ChartType.CustomCompetencyBoxplot;
  }

  get chartTypeMVPlotCompetency(): GEnum.ChartType.MVPlotCompetency {
    return GEnum.ChartType.MVPlotCompetency;
  }

  get chartTypeMVPlotStudent(): GEnum.ChartType.MVPlotStudent {
    return GEnum.ChartType.MVPlotStudent;
  }

  get chartTypeCharacterBoxplot(): GEnum.ChartType.CharacterBoxplot {
    return GEnum.ChartType.CharacterBoxplot;
  }

  get chartTypeCharacterMapping(): GEnum.ChartType.CharacterMapping {
    return GEnum.ChartType.CharacterMapping;
  }

  get chartTypeNetwork(): GEnum.ChartType.Network {
    return GEnum.ChartType.Network;
  }

  get competencyGrowthChart(): GEnum.ChartType.CompetencyGrowthChart {
    return GEnum.ChartType.CompetencyGrowthChart;
  }

  get trendAnalysisChartTypeGrowthMindsetMap(): GEnum.TrendAnalysisChartType.GrowthMindsetMap {
    return GEnum.TrendAnalysisChartType.GrowthMindsetMap;
  }

  get trendAnalysisChartTypePsychologicalSafety(): GEnum.TrendAnalysisChartType.PsychologicalSafety {
    return GEnum.TrendAnalysisChartType.PsychologicalSafety;
  }

  get trendAnalysisChartTypeHumanitiesOrSciences(): GEnum.TrendAnalysisChartType.HumanitiesOrSciences {
    return GEnum.TrendAnalysisChartType.HumanitiesOrSciences;
  }

  get competencies(): Competency[] {
    return masterModule.competencies;
  }

  get schoolClasses(): SchoolClass[] {
    return schoolClassModule.schoolClasses;
  }

  get boxplotSubTableColumns(): any[] {
    return statisticsModule.echartService.subTableColmuns;
  }

  get boxplotSubTableData(): any[] {
    return statisticsModule.echartService.subTableData;
  }

  get isDispBoxplotSubTableInfoTable(): boolean {
    return this.boxplotSubTableData.length > 0;
  }
  get options(): Map<any, any> {
    return statisticsModule.echartService.options;
  }

  get isOptions(): boolean {
    return this.options ? this.options.size > 0 : false;
  }

  get isDisplayTrend(): boolean {
    // 追加サービスプランに傾向チェックが含まれている場合、表示する
    return this.$store.state.account.additionalPlanTypes.includes(GEnum.AdditionalPlanType.TrendCheckAcademic) ||
           this.$store.state.account.additionalPlanTypes.includes(GEnum.AdditionalPlanType.TrendCheckAcademicReadOnly);
  }

  handleChangeChartType(chartType: GEnum.ChartType) {
    if (this.selectedChartType === chartType) {
      // 現在選択中のタブをクリックした場合は何もしない
      return;
    }
    statisticsModule.setSelectedChartType(chartType);
    this.flushChart();
  }

  handleChangeTrendAnalysisChartType(chartType: GEnum.TrendAnalysisChartType) {
    if (this.selectedTrendAnalysisChartType === chartType) {
      // 現在選択中のタブをクリックした場合は何もしない
      return;
    }
    statisticsModule.setSelectedTrendAnalysisChartType(chartType);
    this.flushTrendAnalysisChart();
  }

  // チャート更新
  flushChart() {
    const newChartService: EChartService = this.newChartService();

    if (statisticsModule.selectedChartType !== GEnum.ChartType.Network) {
      statisticsModule.statisticsFilterParams.forEach((_: StatisticsFilterParam, i: number) => {
        newChartService.addLabel(i + 1);
        newChartService.addSeries(statisticsModule.chartData[i]);
      });
    } else {
      newChartService.addSeries(statisticsModule.chartData);
    }
    statisticsModule.setEChartService(newChartService);
  }

  // チャート更新
  flushTrendAnalysisChart() {
    const newChartService: EChartService = this.newTrendAnalysisChartService();
    statisticsModule.statisticsFilterParams.forEach((_: StatisticsFilterParam, i: number) => {
      newChartService.addSeries(statisticsModule.chartDataTrendAnalysis[i]);
    });
    statisticsModule.setTrendAnalysisEChartService(newChartService);
  }

  refreshChart() {
    this.flushChart();
    this.flushTrendAnalysisChart();
  }

  newChartService() {
    switch (this.selectedChartType) {
      case GEnum.ChartType.CompetencyBoxplot:
        return new CompetencyBoxplotEchartService(statisticsModule.competencyByType);
      case GEnum.ChartType.OtherCompetencyBoxplot:
        return new OtherCompetencyBoxplotEchartService(statisticsModule.competencyByType);
      case GEnum.ChartType.CustomCompetencyBoxplot:
        return new CustomCompetencyBoxplotEchartService(statisticsModule.competencyByType, customCompetencyModule.customCompetencyBoxplotForGraph);
      case GEnum.ChartType.CharacterMapping:
        return new CharacterMappingEchartService();
      case GEnum.ChartType.Network:
        return new NetworkEChartService();
      case GEnum.ChartType.CharacterBoxplot:
        return new CharacterBoxplotEchartService();
      case GEnum.ChartType.CompetencyGrowthChart:
        return new StatisticsCompetencyGrowthEchartService(statisticsModule.competencyByType);
      case GEnum.ChartType.MVPlotCompetency:
        return new MvplotCompetencyMappingEchartService(statisticsModule.competencyByType);
      case GEnum.ChartType.MVPlotStudent:
        return new MvplotStudentMappingEchartService(statisticsModule.competencyByType);
    }
  }

  newTrendAnalysisChartService() {
    switch (this.selectedTrendAnalysisChartType) {
      case GEnum.TrendAnalysisChartType.GrowthMindsetMap:
        return new TrendanalysisGrowthMindsetMapEchartService();
      case GEnum.TrendAnalysisChartType.PsychologicalSafety:
        return new TrendanalysisPsychologicalSafetyEchartService();
      case GEnum.TrendAnalysisChartType.HumanitiesOrSciences:
        return new TrendanalysisHumanitiesOrSciencesEchartService();
    }
  }

  createColumn(): void {
    this.growthMindsetMapDescriptionsColumn = [this.zone, this.score, this.description, this.favoritePhrase];
  }

  exportBoxplotData(tableRef: string) {
    const fileNames: any = {
      chartTypeCompetencyBoxplot: this.$t('COMPETENCY_DISTRIBUTION').toString(),
      chartTypeOtherCompetencyBoxplot: this.$t('OTHER_COMPETENCY_DISTRIBUTION').toString(),
      chartTypeCustomCompetencyBoxplot: this.$t('SCHOOL_COMPETENCY_DISTRIBUTION').toString(),
      chartTypeCharacterBoxplot: this.$t('PERSONALITY_DISTRIBUTION_GRAPH_BOXPLOT').toString(),
    };
    const table: any = this.$refs[tableRef];
    table.exportCsv({
      filename: fileNames[tableRef],
    });
  }

  get zone(): any {
    return {
      title: this.$t('ZONE').toString(),
      key: 'zone',
      width: 140,
      align: 'left',
    };
  }

  get score(): any {
    return {
      title: this.$t('SCORE').toString(),
      key: 'score',
      width: 130,
      align: 'left',
      render: (h: any, params: any) => {
        return this.renderIViewTableCellWithLineBreaks(h, params.row.score);
      },
    };
  }

  get description(): any {
    return {
      title: this.$t('SENTENCE').toString(),
      key: 'description',
      align: 'left',
    };
  }

  get favoritePhrase(): any {
    return {
      title: this.$t('FAVORITE_SAYING').toString(),
      key: 'favoritePhrase',
      width: 180,
      align: 'left',
      render: (h: any, params: any) => {
        return this.renderIViewTableCellWithLineBreaks(h, params.row.favoritePhrase);
      },
    };
  }
}
